const bookingInfo = require('components/user_area/booking_info');
const membershipRepository = require('od-modules/xsell/repositories/membership_repository');
const xsellController = import(/* webpackChunkName: "module-xsell" */ 'od-modules/xsell/controller');
const isRedirectionFromConfirmation = require('od-modules/xsell/utils').isRedirectionFromConfirmation;

const getBookingInfo = (bookingId, bookingMail) => {
    const bookingInfoFromSession = Odigeo.Utils.parseJson(Odigeo.Session.get('bookingInfo')) || {};
    const isHSABooking = bookingInfoFromSession.itineraryBookings === null && bookingInfoFromSession.accommodationBooking !== null;
    return {
        bookingId: bookingId ? bookingId : bookingInfo.bookingId,
        buyer: {
            mail: bookingMail ? bookingMail : bookingInfo.mail,
            isPrimeUser: membershipRepository.isPrimeUser(),
        },
        isPrimeEnabled: Odigeo.AB.isPrimeEnabled && !Odigeo.Utils.isRequestApp('dp'),
        isHSABooking,
        data: {'userDTO': {'bookingDetail': [bookingInfoFromSession]}},
        destinationCity: bookingInfo.destinationCity,
    };
};

const openDeepLinkByProduct = (product, bookingId, bookingMail, touchpoint) => {
    const productLabels = {
        CARS: 'car',
        ACCOMMODATION: 'hotel',
        ACTIVITIES: 'activities',
        TRANSFERS: 'transfer',
    };
    const bookingInfo = getBookingInfo(bookingId, bookingMail);
    const isAutomaticRedirection = isRedirectionFromConfirmation(bookingInfo.bookingId);
    const selectedProduct = productLabels[product] || product;
    xsellController.then(({default: controller}) => {
        const xsellModule = controller();
        const hotelTouchpoint = touchpoint || xsellModule.touchpoints.mytripsdetails_hotels_itinerary_textlink;
        xsellModule.setItinerary(bookingInfo.data.userDTO.bookingDetail[0]);
        xsellModule.setIsRedirection(isAutomaticRedirection);

        switch (selectedProduct) {
            case 'car':
                xsellModule.openCarsDeepLink(xsellModule.touchpoints.mytripdetails_cars_itinerary_textlink);
                break;
            case 'hotel':
                xsellModule.openHotelsDeepLink(hotelTouchpoint);
                break;
            case 'transfer':
                xsellModule.openGtDeepLink(xsellModule.touchpoints.mytripsdetails_gt_itinerary_textlink);
                break;
            case 'activities':
                xsellModule.openActivitiesDeepLink(xsellModule.touchpoints.mytripdetails_gyg_itinerary_textlink);
                break;
        }
    });
};

const navigateOutside = (page = '') => {
    Odigeo.Router.navigate(page);
};

module.exports = {
    getBookingInfo,
    openDeepLinkByProduct,
    navigateOutside,
};
